import { api } from './client';

/** ч.1015, Етап 5: консоль підтримки (служба, наскрізно по клієнтах). */
export type QueueFilter = 'open' | 'escalated' | 'all';

export interface QueueItem {
  id: string;
  public_id: string;
  title: string;
  status: string;
  category: string | null;
  route_pattern: string | null;
  tenant_name: string | null;
  user_name: string | null;
  /** ч.1425: звернення з головної сторінки: облікового запису немає, відповідь — на цю пошту. */
  contact_email?: string | null;
  assignee_id: string | null;
  escalated: boolean;
  last_message_at: string;
  created_at: string;
}

export interface ConsoleMessage {
  id: string;
  author_kind: 'user' | 'agent' | 'staff';
  author_name: string | null;
  body: string;
  is_internal_note: boolean;
  has_screenshot: boolean;
  /** ч.1091: 'screenshot' | 'kep_letter' (лист із КЕП у запиті скидання 2FA). */
  attachment_kind: 'screenshot' | 'kep_letter' | null;
  created_at: string;
}

export interface ConsoleAttachment {
  content: string;   // data-URL
  kind: 'screenshot' | 'kep_letter';
  mime_type: string;
}

export interface ConsoleCase extends QueueItem {
  messages: ConsoleMessage[];
}

export interface KbSuggestion {
  id: string;
  case_id: string | null;
  case_public_id: string | null;
  article_slug: string | null;
  article_title: string | null;
  route_pattern: string | null;
  question: string;
  answer: string;
  created_at: string;
}

export const supportConsole = {
  /** ч.1019: чернетки доповнення довідника. */
  suggestions: () =>
    api.get<KbSuggestion[]>('/support-console/suggestions').then((r) => r.data),

  acceptSuggestion: (id: string, edited_answer?: string | null) =>
    api.post<{ status: string; article_slug: string }>(
      `/support-console/suggestions/${id}/accept`,
      { edited_answer: edited_answer ?? null }).then((r) => r.data),

  rejectSuggestion: (id: string) =>
    api.post(`/support-console/suggestions/${id}/reject`).then(() => undefined),

  queue: (status_filter: QueueFilter = 'open') =>
    api.get<QueueItem[]>('/support-console/queue', { params: { status_filter } })
      .then((r) => r.data),

  case: (id: string) =>
    api.get<ConsoleCase>(`/support-console/cases/${id}`).then((r) => r.data),

  reply: (id: string, body: string, internal = false, set_status?: string) =>
    api.post<ConsoleCase>(`/support-console/cases/${id}/reply`,
      { body, internal, set_status: set_status ?? null }).then((r) => r.data),

  assign: (id: string, to_me = true) =>
    api.post<ConsoleCase>(`/support-console/cases/${id}/assign`, null,
      { params: { to_me } }).then((r) => r.data),

  screenshot: (messageId: string) =>
    api.get<ConsoleAttachment>(
      `/support-console/messages/${messageId}/screenshot`).then((r) => r.data),

  /** ч.1091: скинути двофакторний вхід за зверненням TWO_FACTOR_RESET
   *  (усі сесії користувача завершуються, пишеться аудит). */
  twoFactorReset: (id: string, note?: string | null) =>
    api.post<ConsoleCase>(`/support-console/cases/${id}/two-factor-reset`,
      { note: note ?? null }).then((r) => r.data),
};

export default supportConsole;
